// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3_C1f","fileBtn":"File_fileBtn__139Sk","closeBtn":"File_closeBtn__3rzS8","fileSelected":"File_fileSelected__21onT","disabled":"File_disabled__Z99B2"};